<template>
  <div class="animated fadeIn">
    <div class="row">
      <div class="col-lg-12">
        <div class="card">
          <div class="card-header bg-transparent">
            Welcome to EIB Risk Factor Tool
            <hr />
          </div>
          <div class="card-body">
            <div class="row">
              <div class="col-lg-4">
                <div class="callout callout-info">
                  <small class="text-muted"> Last update </small>
                  <div class="text-value-lg">{{ dates.process_date }}</div>
                </div>
              </div>
              <div class="col-lg-4">
                <div class="callout callout-info">
                  <small class="text-muted"> Last tender extraction </small>
                  <div class="text-value-lg">{{ dates.ted_date }}</div>
                </div>
              </div>
              <div class="col-lg-4">
                <div class="callout callout-info">
                  <small class="text-muted"> Next update </small>
                  <div class="text-value-lg">{{ dates.next_date }}</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="row charts justify-content-between flex-nowrap">
      <div class="col-lg-6">
        <div class="card">
          <div class="card-header bg-transparent">
            Number of tenders per year
            <hr />
          </div>
          <div class="card-body">
            <div class="bar-chart-wrapper" v-if="isLoading">
              <div class="spinner-border" role="status"></div>
            </div>
            <div class="bar-chart-wrapper" v-else>
              <canvas id="barChart1"></canvas>
            </div>
          </div>
        </div>
      </div>
      <div class="col-lg-6">
        <div class="card">
          <div class="card-header bg-transparent">
            Number of tenders by country
            <hr />
          </div>
          <div class="card-body">
            <div class="bar-chart-wrapper" v-if="isLoading">
              <div class="spinner-border" role="status"></div>
            </div>
            <div class="bar-chart-wrapper" v-else>
              <canvas id="barChart2"></canvas>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="row justify-content-between flex-nowrap">
      <div class="col-lg-6">
        <div class="card">
          <div class="card-header bg-transparent">
            <div class="d-flex justify-content-between align-items-center">
              Score Evolution
              <div class="justify-content-between gap-1">
                <input
                  type="checkbox"
                  class="ml-2 mr-1 custom-checkbox"
                  id="bidder"
                  name="bidder"
                  v-model="bidder_state"
                  @change="updateLine('bidder', bidder_state)"
                />
                <label for="bidder">Bidder</label>
                <input
                  class="ml-2 mr-1 custom-checkbox"
                  type="checkbox"
                  id="buyer"
                  name="buyer"
                  v-model="buyer_state"
                  @change="updateLine('buyer', buyer_state)"
                />
                <label for="buyer">Buyer</label>
              </div>
            </div>
            <hr />
          </div>
          <div class="card-body">
            <div class="bar-chart-wrapper" v-if="isLoading">
              <div class="spinner-border" role="status"></div>
            </div>
            <div class="bar-chart-wrapper" v-else>
              <canvas id="Line1"></canvas>
            </div>
            <div class="row">
              <div class="float-left">
                <small>Country</small>
                <select
                  class="selectpicker form-control custom"
                  style="border-radius: 6px"
                  @change="updateCountry($event)"
                  v-model="selected_country"
                >
                  <option>All</option>
                  <option v-for="country in countries">{{ country }}</option>
                </select>
              </div>
            </div>
            <div class="row">
              <div class="float-left">
                <small>Sector</small>
                <select
                  class="selectpicker form-control custom"
                  style="border-radius: 6px"
                  @change="updateCountry($event)"
                  v-model="selected_sector"
                >
                  <option>All</option>
                  <option v-for="sect in descr">{{ sect }}</option>
                </select>
              </div>
            </div>
            <div class="row">
              <div class="float-left">
                <small> &nbsp; </small>
                <button
                  @click="
                    $downloadFile({
                      name: 'score_collection.xlsx',
                      fileId: 1,
                      url: `${baseUrl}/score_collection`,
                    })
                  "
                  class="btn btn-block btn-outline-primary"
                >
                  <i class="fa fa-download pr-1" />
                  Download KPI File
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-lg-6">
        <div class="card">
          <div class="card-header bg-transparent">
            Top Scored Entities
            <hr />
          </div>
          <div class="card-body">
            <ul v-for="item in res_top['bidder']" v-if="bidder_state">
              {{
                item.company
              }}
              :
              {{
                item.new_res
              }}M €
            </ul>
            <ul v-for="item in res_top['buyer']" v-if="buyer_state">
              {{
                item.company
              }}
              :
              {{
                item.new_res
              }}M €
            </ul>
          </div>
        </div>
        <div class="card">
          <div class="card-header bg-transparent">
            Top Scored EIB Entities
            <hr />
          </div>
          <div class="card-body">
            <ul v-for="item in res_top_eib['bidder']" v-if="bidder_state">
              {{
                item.company
              }}
              :
              {{
                item.new_res
              }}M €
            </ul>
            <ul v-for="item in res_top_eib['buyer']" v-if="buyer_state">
              {{
                item.company
              }}
              :
              {{
                item.new_res
              }}M €
            </ul>
          </div>
        </div>
      </div>
    </div>
    <div class="row justify-content-between flex-nowrap">
      <div class="col-lg-6">
        <div class="card">
          <div class="card-header bg-transparent">
            <div
              class="
                d-flex
                align-items-center
                justify-content-between
                flex-nowrap
              "
            >
              <span> Maps </span>
              <div>
                <div class="form-check form-check-inline">
                  <input
                    id="checkbox1"
                    class="form-check-input"
                    type="radio"
                    value="ca_value"
                    v-model="map"
                    @change="drawMap()"
                  />
                  <label class="form-check-label" for="checkbox1"
                    >Contract Value (in €)</label
                  >
                </div>
                <div class="form-check form-check-inline">
                  <input
                    id="checkbox2"
                    class="form-check-input"
                    type="radio"
                    value="td_volume"
                    v-model="map"
                    @change="drawMap()"
                  />
                  <label class="form-check-label" for="checkbox2"
                    >Tenders Volume</label
                  >
                </div>
                <div class="form-check form-check-inline">
                  <input
                    id="checkbox3"
                    class="form-check-input"
                    type="radio"
                    value="avg_score"
                    v-model="map"
                    @change="drawMap()"
                  />
                  <label class="form-check-label" for="checkbox3"
                    >Score Average</label
                  >
                </div>
              </div>
            </div>
            <hr />
          </div>
          <div class="card-body">
            <div id="regions_div" style="width: 100%; height: 550px"></div>
          </div>
        </div>
      </div>
      <div class="col-lg-6">
        <div class="card">
          <div class="card-header bg-transparent">
            KPI Sectors
            <hr />
          </div>
          <div class="card-body">
            <div v-for="item in sector_kpi" class="d-flex justify-content-between flex-nowrap pt-2 pb-2">
              <div>
                <img :src="`/img/${icons[item.sector]}`" />
                  {{ groups[item.sector] }}
              </div>
              <div>
                <span v-if="map === 'ca_value'">{{ item.contract_value }}M €</span>
                <span v-if="map === 'td_volume'">{{ item.tender_volume }}</span>
                <span v-if="map === 'avg_score'">{{ item.score_avg }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { BASE_URL } from "@/constants/config";

export default {
  name: "Home",
  data() {
    return {
      bidder_state: false,
      isLoading: false,
      buyer_state: true,
      selected_country: "All",
      selected_sector: "All",
      createdCharts: [],
      countries: [],
      sectors: [],
      dates: [],
      icons: {},
      groups: {},
      map: "ca_value",
      descr: [],
      country_kpi: [],
      sector_kpi: [],
      chart_data: {},
      res_top: {},
      res_top_eib: {},
      unique: 0,
      api_key: "AIzaSyCizLUZSdiuXvk0d-iuPjHm-eaTLkfUyOI",
      deployed: 0,
      non_interface: 0,
      test: "",
      baseUrl: `${BASE_URL}api/overview`,
    };
  },
  async mounted() {
    await this.fetchChartData();
    this.makeBarChart(
      this.chart_data.first_chart.labels,
      this.chart_data.first_chart.datasets,
      "barChart1",
      false,
      false,
      false,
      false
    );
    this.makeBarChart(
      this.chart_data.second_chart.labels,
      this.chart_data.second_chart.datasets,
      "barChart2",
      false,
      false,
      false,
      false
    );
    this.makeLine();
    this.drawMap();
  },
  methods: {
    async fetchChartData() {
      this.isLoading = true;
      this.dates = (
        await this.$request({ url: `${this.baseUrl}/dateprocess` })
      )["data"];
      this.chart_data.first_chart = (
        await this.$request({ url: `${this.baseUrl}/chart/first` })
      )["data"];
      this.chart_data.second_chart = (
        await this.$request({ url: `${this.baseUrl}/chart/second` })
      )["data"];

      this.res_top = (
        await this.$request({ url: `${this.baseUrl}/top_five/All/All` })
      )["data"];
      this.res_top_eib = (
        await this.$request({ url: `${this.baseUrl}/top_five_eib/All/All` })
      )["data"];

      this.countries = (
        await this.$request({ url: `${this.baseUrl}/countries/buyer` })
      )["data"];
      this.sectors = (await this.$request({ url: `${this.baseUrl}/sectors` }))[
        "data"
      ];
      this.icons = (await this.$request({ url: `${this.baseUrl}/icons` }))[
        "data"
      ];
      this.groups = (await this.$request({ url: `${this.baseUrl}/groups` }))[
        "data"
      ];

      this.country_kpi = (
        await this.$request({ url: `${this.baseUrl}/country_kpi` })
      )["data"];
      this.sector_kpi = (
        await this.$request({ url: `${this.baseUrl}/sector_kpi` })
      )["data"];
      this.score_kpi = (
        await this.$request({ url: `${this.baseUrl}/score_kpi/All/All` })
      )["data"];
      this.descr = Object.keys(this.sectors);

      this.isLoading = false;
    },
    drawMap() {
      let map_data = {};
      if (this.map === "td_volume") {
        map_data = this.country_kpi["volume"];
      } else if (this.map === "ca_value") {
        map_data = this.country_kpi["sum"];
      } else {
        map_data = this.country_kpi["avg"];
      }
      google.charts.load("current", {
        packages: ["geochart"],
        mapsApiKey: this.api_key,
      });
      google.charts.setOnLoadCallback(drawRegionsMap);
      function drawRegionsMap() {
        const data = google.visualization.arrayToDataTable(map_data);
        const options = {
          legend: { numberFormat: "long" },

          region: "150",
          colorAxis: { colors: ["#DAEEFB", "#0F5F95"] },
        };
        const chart = new google.visualization.GeoChart(
          document.getElementById("regions_div")
        );
        chart.draw(data, options);
      }
    },
    async updateCountry($event) {
      const country = this.selected_country;
      const sect = this.selected_sector;
      const code = this.selected_sector !== "All" ? this.sectors[sect] : "All";
      this.score_kpi = (
        await this.$request({
          url: `${this.baseUrl}/score_kpi/${country}/${code}`,
        })
      )["data"];
      this.res_top = (
        await this.$request({
          url: `${this.baseUrl}/top_five/${country}/${code}`,
        })
      )["data"];
      this.res_top_eib = (
        await this.$request({
          url: `${this.baseUrl}/top_five_eib/${country}/${code}`,
        })
      )["data"];
      this.lineChart.destroy();
      this.makeLine();
    },
    async updateLine(type, input) {
      if (input) {
        if (type === "buyer") {
          this.bidder_state = false;
          this.countries = (
            await this.$request({ url: `${this.baseUrl}/countries/buyer` })
          )["data"];
        } else {
          this.buyer_state = false;
          this.countries = (
            await this.$request({ url: `${this.baseUrl}/countries/bidder` })
          )["data"];
        }
      } else {
        if (type === "bidder") {
          this.buyer_state = true;
          this.countries = (
            await this.$request({ url: `${this.baseUrl}/countries/bidder` })
          )["data"];
        } else {
          this.buyer_state = true;
          this.countries = (
            await this.$request({ url: `${this.baseUrl}/countries/buyer` })
          )["data"];
        }
      }
      this.makeLine();
    },
    makeLine() {
      const chartId = "Line1";
      const labels = this.score_kpi.labels;
      const value = this.buyer_state
        ? this.score_kpi.buyer
        : this.bidder_state
        ? this.score_kpi.bidder
        : [];
      const options = {
        type: "line",
        data: {
          labels: labels,
          datasets: value,
        },
        options: {
          legend: {
            display: true,
          },
          scales: {
            yAxes: [
              {
                ticks: {
                  beginAtZero: true,
                  callback: function (value, index, values) {
                    return value.toLocaleString("fr-FR");
                  },
                },
                scaleLabel: {
                  display: true,
                },
              },
            ],
            xAxes: [
              {
                scaleLabel: {
                  display: true,
                },
              },
            ],
          },
          responsive: true,
          maintainAspectRatio: false,
        },
      };
      const ctx = document.getElementById(chartId).getContext("2d");
      if (this.lineChart) {
        this.lineChart.destroy();
      }
      this.lineChart = new Chart(ctx, options);
    },
    makeBarChart(
      labels,
      datasets,
      chartId,
      isHorizontal,
      displayLegend,
      istooltips,
      isClick
    ) {
      const options = {
        type: isHorizontal ? "horizontalBar" : "bar",
        data: {
          labels: labels,
          datasets: datasets,
        },
        options: {
          tooltips: {
            enabled: "true",
            mode: "single",
          },
          legend: {
            display: displayLegend,
          },
          title: {
            fontSize: 20,
            display: true,
            text: "",
          },
          scales: {
            yAxes: [
              {
                gridLines: {
                  display: !isHorizontal,
                },
                stacked: true,
                ticks: {
                  beginAtZero: true,
                  callback: function (value, index, values) {
                    return value.toLocaleString("fr-FR");
                  },
                },
                scaleLabel: {
                  display: true,
                },
              },
            ],
            xAxes: [
              {
                gridLines: {
                  display: isHorizontal,
                },
                stacked: true,
                scaleLabel: {
                  display: true,
                },
              },
            ],
          },
          responsive: true,
          maintainAspectRatio: false,
        },
      };
      const ctx = document.getElementById(chartId).getContext("2d");
      const chart = new Chart(ctx, options);
      this.createdCharts.push(chart);
    },
  },
};
</script>

<style lang="scss">
.card-header {
  font-weight: bold;
  font-size: 1.05rem;
  hr {
    width: 100%;
    margin: 1rem 0 1rem 0 !important;
    border: 1px solid rgba(0, 0, 0, 0.1);
  }
}
.card-body {
  font-size: 1rem;
  font-weight: bold;
}

input,
label {
  font-size: 1rem;
}
.number-stats {
  background-color: #3a75b6;
  border-radius: 5px;
  text-align: center;
  flex: 1;
  margin: 10px 30px;
}

.bar-chart {
  background-color: #3a75b6;
  border-radius: 20px;
  padding: 30px;
  margin: 10px;
}

.bar-chart-wrapper {
  position: relative;
  height: 30vh;
  width: 97%;
}

.charts .bar-chart {
  background-color: #fafafa;
  border: 1px solid #dedede;
  border-radius: 20px;
  flex: 1;
}

.card {
  background-color: #fafafa;
  border: 1px solid #dedede;
  border-radius: 20px;
  padding: 20px;
  margin: 10px;
  flex: 1;
}

.charts h3 {
  color: #3a75b6;
  text-align: center;
}

hr {
  margin: 10px 30px 0 !important;
  border: 1px solid #3a75b6;
}

h1 {
  font-size: 40px;
}

h2 {
  font-size: 20px;
}

ul {
  padding: 0;
  list-style-type: none;
}
</style>
